import type { IssueTypePriority } from "@overmap-ai/common"

import { FilterModifier } from "./FilterModifier"

export const IssuePriorityEqualsFilterModifier = FilterModifier.create<
	IssueTypePriority["uuid"],
	IssueTypePriority["uuid"]
>({
	id: "issue-priority-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssuePriorityNotEqualsFilterModifier = FilterModifier.create<
	IssueTypePriority["uuid"],
	IssueTypePriority["uuid"]
>({
	id: "issue-priority-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssuePriorityIncludesFilterModifier = FilterModifier.create<
	IssueTypePriority["uuid"],
	IssueTypePriority["uuid"][]
>({
	id: "issue-priority-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssuePriorityExcludesFilterModifier = FilterModifier.create<
	IssueTypePriority["uuid"],
	IssueTypePriority["uuid"][]
>({
	id: "issue-priority-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
